// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchGridResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventUtils = require('EventUtils');

  var action = require('./Izenda.SearchGridResultAction');
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var AffixContainer = require('share/components/controls/Izenda.AffixContainer');
  var Input = require('share/components/controls/Izenda.Input');
  var Button = require('share/components/controls/Izenda.Button');
  var OverflowText = require('share/components/controls/Izenda.OverflowText');
  var CONSTANTS = require('logic/data/Izenda.SchedulingSearchConstants');
  var TABLE_DEF = CONSTANTS.TABLE_DEF;
  var ACTION_TEXT = CONSTANTS.ACTION_TEXT;
  var TOOLTIP = CONSTANTS.TOOLTIP;
  const { getOr, map, split, merge, values } = require('lodash/fp');

  var SearchGridFooter = connect()(function(props) {
    var data = props.data;
    var pageInfo = data.pageInfo;

    return (
      <Paginator
        onChange={props.goToPage}
        onDropdownChange={props.onSetPageSize}
        pageInfo={pageInfo}
        currentPageSize={getOr(0, 'length', data.schedules)}
      />
    );
  });

  var SearchGridResult = React.createClass({
    getInitialState: function() {
      return {
        show: true
      };
    },

    /**
     * Render selectable cell
     */
    renderSelectCell: function(schedule, key) {
      var handleChange = function(value) {
        schedule.updateSelected(value);
      };

      return (
        <Input
          type="checkbox"
          value={schedule.getDataByKey(key)}
          checked={schedule.getDataByKey(key)}
          onChange={EventUtils.notifyChange(handleChange, EventUtils.CHECKBOX)}
        />
      );
    },

    /**
     * Render Action button cell
     */
    renderAction: function(schedule, key, rowIndex) {
      var props = this.props;
      return (
        <div>
          <a>
            <span title={ACTION_TEXT.EditText} className="icon-pencil" onClick={handleClickEdit} value={schedule} />
          </a>
          <a>
            <span
              title={ACTION_TEXT.DeleteText}
              className="icon-cancel"
              onClick={handleDeleteSchedule}
              value={rowIndex}
            />
          </a>
        </div>
      );

      /**
       * Handle edit button, open edit popup
       */
      function handleClickEdit() {
        props.openEditPopup(schedule);
      }

      /**
       * handle delete schedule
       */
      function handleDeleteSchedule() {
        props.deleteSchedule(schedule);
      }
    },

    /**
     * Render text cell
     */
    renderTextCell: function(schedule, key) {
      var value = schedule.getDataByKey(key);
      switch (key) {
        case 'recipients':
          return <OverflowText tooltip={value} text={value} />;
        default:
          return <span title={value}>{value}</span>;
      }
    },

    /**
     * render separated line for one cell
     */
    renderSeparatedLine: function(value, separator) {
      if (value) {
        return map(function(item) {
          return <span title={item}>{item}</span>;
        }, split(separator, value));
      }
    },

    /**
     * Render columns
     * @returns {Array}
     */
    renderColumns: function() {
      var data = this.props.data;

      var checkBoxSelectAllProps = {
        checked: data.isAllChecked,
        onChange: EventUtils.notifyChange(handleSelectHeaderChange, EventUtils.CHECKBOX),
        type: 'checkbox'
      };

      var headerSelectDef = merge(TABLE_DEF['selected'], {
        headerComponent: Input,
        headerComponentProps: checkBoxSelectAllProps
      });

      return map(
        function(item) {
          switch (item.key) {
            case 'selected':
              return <Column {...headerSelectDef} cell={this.renderSelectCell} />;
            case 'action':
              return <Column {...item} cell={this.renderAction} />;
            default:
              return <Column {...item} cell={this.renderTextCell} />;
          }
        }.bind(this),
        values(TABLE_DEF)
      );

      function handleSelectHeaderChange(value) {
        data.updateSelected(value);
      }
    },

    render: function() {
      var props = this.props;
      var data = props.data;
      var collapseIcon = this.state.show ? 'icon-triangle-down' : 'icon-triangle-right';
      var titleIcon = this.state.show ? TOOLTIP.COLLAPSE : TOOLTIP.EXPAND;
      return (
        <AffixContainer getAffix={this.getAffix}>
          <div ref="affix" className="izenda-SearchResult_Affix u_paddingAll u_fullWidth u_inlineBlock">
            <a onClick={this.toggleShowGrid}>
              <span title={titleIcon} className={collapseIcon} />
            </a>
            <span className="u_controlHeight">{props.name}</span>
            <Button
              disabled={!data.isOneChecked}
              label="Delete"
              className="u_floatRight btn-setting-default"
              onClick={props.deleteSelectedSchedules}
            />
          </div>
          {this.state.show ? (
            <div>
              <Table
                dataSource={data.schedules}
                onSortChange={props.handleChangeSortDirs}
                draggableTable={false}
                sortInfo={data.pageInfo.colSortDirs}
              >
                {this.renderColumns()}
              </Table>
              <SearchGridFooter data={props.data} goToPage={props.goToPage} onSetPageSize={props.setPageSize} />
            </div>
          ) : null}
        </AffixContainer>
      );
    },

    /**
     * get affix dom for sticky header
     */
    getAffix: function() {
      return this.refs.affix;
    },

    /**
     * Toggle show grid or not
     */
    toggleShowGrid: function() {
      this.setState({
        show: !this.state.show
      });
    }
  });

  module.exports = connect(action)(SearchGridResult);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.SearchGridResult.jsx